import styled from 'styled-components';

export const TableContainer = styled.div`
  grid-area: History;
  margin-top: 15px;
`;


export const Header = styled.div`
  padding:  15px 0px;

  h2 {
    margin: 0 0 8px 0;
    font-size: 1.75rem;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: -0.02em;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const HeaderRow = styled.div`
display: flex;
flex-direction: column;
align-items: end;
align-self: flex-end;
margin-bottom: 16px;

`;

export const WalletBalance = styled.span`
font-size: 1.05rem;
font-weight: 600;
color: #2e7d32;
border-radius: 6px;
letter-spacing: 0.5px;
`;
